import { useTranslation } from 'react-i18next';
import { useEffect, useState, useRef } from 'react';
import Page from '@/components/Page';
import entranceLogo from '@/assets/images/entranceLogo.svg';
import backgroundImage from '@/assets/images/sky-background.jpg';
import clsx from 'clsx';
import { useVideo } from '@/contexts/ContentContext';
import classes from './main.module.css';

const Main = () => {
  const { t } = useTranslation();
  const [showDescription, setShowDescription] = useState(false);
  const [videoFadeOut, setVideoFadeOut] = useState(false);
  const videoRef = useRef(null);
  const { setIsVideoEnded } = useVideo();

  useEffect(() => {
    const videoElement = videoRef.current;

    const handleEntranceComplete = () => {
      setVideoFadeOut(true);
      setShowDescription(true);
      setIsVideoEnded(true);
    };

    const timeoutId = setTimeout(handleEntranceComplete, 2000);

    if (videoElement) {
      videoElement.addEventListener('ended', handleEntranceComplete);
    }

    return () => {
      clearTimeout(timeoutId);
      if (videoElement) {
        videoElement.removeEventListener('ended', handleEntranceComplete);
      }
    };
  }, [setIsVideoEnded]);

  return (
    <Page backgroundImage={backgroundImage} isFull>
      <div className={classes.container}>
        <video
          ref={videoRef}
          autoPlay
          muted
          playsInline
          className={clsx(classes.background, {
            [classes.backgroundFadeOut]: videoFadeOut,
          })}
          preload="auto"
          controls={false}
        >
          <source src="/stars_video.mov" type="video/quicktime" />
          <source src="/stars_video.mov" type="video/mp4" />
          <source src="/stars_video.mov" type="video/x-m4v" />
        </video>

        {!showDescription ? (
          <div className={classes.content}>
            <img src={entranceLogo} alt="Polaris Logo" className={classes.entranceLogo} />
            <div className={classes.entranceTitleText}>
              <div dangerouslySetInnerHTML={{ __html: t('pages.main.title.entrance') }} />
            </div>
          </div>
        ) : (
          <div className={classes.textContainer}>
            <div dangerouslySetInnerHTML={{ __html: t('pages.main.title.main') }} />
          </div>
        )}
      </div>
    </Page>
  );
};

export default Main;
